<template>
	<div class="sf-input-group-wrapper">
		<!--처리단계-->
		<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC000963') }}</span>
		<div class="search-option-wrapper__normal">
			<el-select v-model="data" @change="change">
				<!--전체-->
				<el-option :label="getMessage_('MWCC000753')" value=""></el-option>
				<el-option
					:key="index"
					v-for="(prcStepGb, index) in prcsStepList"
					:label="prcStepGb.commCdName"
					:value="prcStepGb.commCd"
				></el-option>
			</el-select>
		</div>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/ceqi/PwaApcn/store/helpers';
export default {
	data() {
		return {
			data: null
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		change(value) {
			this.setSearchParam_({ key: 'prcStepGb', value: value }).then(() => {
				this.$emit('reload', 1, 10);
			});
		},
		processInfo() {
			this.data = this.searchParams.prcStepGb;
		}
	},
	created() {
		if (this.searchParams.prcStepGb == null || this.searchParams.prcStepGb == '') this.searchParams.prcStepGb = '';
		this.data = this.searchParams.prcStepGb;
	}
};
</script>

<style></style>
